<template>
  <div class="search">
    <el-select v-model="value"
               placeholder="商品"
               size="small"
               class="item-select"
               popper-class="tophead-select-popper"
               :popper-append-to-body="false"
               @change="changePlat">
      <el-option v-for="item in options"
                 :key="item.value"
                 :label='item.label'
                 :value='item.value'>
      </el-option>
    </el-select>
    <!-- 商品搜索筛选 -->
    <div v-if="showSearch == 'item'"
         ref="itemPopover">
      <el-popover width="360"
                  trigger="click"
                  placement="bottom">
        <el-input :placeholder="itemInput"
                  class="search-input"
                  v-model="titleWord"
                  size="small"
                  slot="reference"
                  @blur="getFormatKeywordMethod(titleWord, 'blur')"
                  @focus="keyWordFocus"
                  @keyup.enter.native="searchTitleWords">
          <el-button slot="append"
                     class="select-search-btn"
                     @click="searchTitleWords"
                     :loading="isSearchLoading"
                     icon="el-icon-search"></el-button>
        </el-input>
        <div class="sku-title">请选择一种搜索方案：
          <span class="sku-tip">(输入商品链接时无需选择)</span>
        </div>
        <el-radio v-model="titleTyp"
                  label="skuandtitle"
                  @change="changeSkuTitle('skuandtitle')">在SKU名字 + 商品标题中搜索</el-radio>
        <el-radio v-model="titleTyp"
                  label="sku"
                  @change="changeSkuTitle('sku')">只在SKU名字中搜索</el-radio>
        <el-radio v-model="titleTyp"
                  label="skuortitle"
                  @change="changeSkuTitle('skuortitle')">在SKU名字中搜索,SKU名为空时在商品标题中搜索</el-radio>
      </el-popover>
      <el-tooltip class="tool-item-keyword"
                  effect="dark"
                  placement="bottom">
        <div slot="content">
          <div style="width:300px">
            <p>商品关键词和评论关键词支持使用“and”、“or”、“not”的筛选条件， <span style="color:yellow; font-size:15px">与汉字用空格隔开。</span></p>
            <p>如： “小米 and 华为”表示关键词既包含“小米”又包含“华为”</p>
            <p>“小米 or 华为 ” 表示关键词“小米”“华为”至少包含其一</p>
            <p>“小米 not 华为” 表示关键词包含“小米”且不包含“华为”</p>
          </div>
        </div>
        <i class="iconfont icon-Hint"></i>
      </el-tooltip>
      <el-popover width="360"
                  v-model="visible"
                  trigger="manual"
                  placement="bottom">
        <el-button class="keyword-search"
                   size="small"
                   slot="reference"
                   @click="getFormatKeywordMethod(titleWord, 'click')">关键词检查</el-button>
        <div v-if="format_parse"
             style="padding:12px">
          <i class="el-icon-close"
             style="position:absolute;cursor:pointer;right:6px;top:6px;"
             @click.stop="visible = false"></i>
          <div style="font-size:13px">{{parse_word_title}}</div>
          <div style="font-size:13px"
               v-if="parse_word_subtitle">{{parse_word_subtitle}}</div>
          <div style="font-size:14px;color:#69c0ff;padding:5px 0"
               v-html="format_parse"></div>
          <div style="font-size:13px">确认逻辑无误再提交搜索，数据更精准哦</div>
        </div>
      </el-popover>
    </div>
    <!-- 品牌搜索筛选 -->
    <div v-if="showSearch == 'brand'">
      <el-popover width="360"
                  trigger="manual"
                  placement="bottom">
        <el-select v-model="brandWord"
                   filterable
                   remote
                   reserve-keyword
                   :placeholder="brandInput"
                   :remote-method="remoteMethod"
                   :loading="brandLoading"
                   class="search-input"
                   style="width: 330px; margin: 0;"
                   size="small"
                   slot="reference">
          <el-option v-for="item in brandOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
                     @click.native="addBrandId(item.value)" />
        </el-select>
      </el-popover>
      <el-tooltip class="tool-item"
                  effect="dark"
                  placement="bottom">
        <div slot="content">
          <div style="width:300px">
            <p>商品关键词和评论关键词支持使用“and”、“or”、“not”的筛选条件， <span style="color:yellow; font-size:15px">与汉字用空格隔开。</span></p>
            <p>如： “小米 and 华为”表示关键词既包含“小米”又包含“华为”</p>
            <p>“小米 or 华为 ” 表示关键词“小米”“华为”至少包含其一</p>
            <p>“小米 not 华为” 表示关键词包含“小米”且不包含“华为”</p>
          </div>
        </div>
        <i class="iconfont icon-Hint"></i>
      </el-tooltip>
      <el-button slot="append"
                 @click="open"
                 icon="el-icon-search"
                 class="open-btn"></el-button>
    </div>
    <!-- 评论搜索筛选 -->
    <div v-if="showSearch == 'comment'"
         ref="commentPopover">
      <el-input :placeholder="commentInput"
                class="search-input"
                v-model="commentWord"
                size="small"
                @blur="getFormatKeywordMethod(commentWord, 'blur')"
                @focus="keyWordFocus"
                @keyup.enter.native="searchCommentWords">
        <el-button slot="append"
                   class="select-search-btn"
                   @click="searchCommentWords"
                   icon="el-icon-search"></el-button>
      </el-input>
      <el-tooltip class="tool-item-keyword"
                  effect="dark"
                  placement="bottom">
        <div slot="content">
          <div style="width:300px">
            <p>商品关键词和评论关键词支持使用“and”、“or”、“not”的筛选条件， <span style="color:yellow; font-size:15px">与汉字用空格隔开。</span></p>
            <p>如： “小米 and 华为”表示关键词既包含“小米”又包含“华为”</p>
            <p>“小米 or 华为 ” 表示关键词“小米”“华为”至少包含其一</p>
            <p>“小米 not 华为” 表示关键词包含“小米”且不包含“华为”</p>
          </div>
        </div>
        <i class="iconfont icon-Hint"></i>
      </el-tooltip>
      <el-popover width="360"
                  v-model="visible"
                  trigger="manual"
                  placement="bottom">
        <el-button class="keyword-search"
                   size="small"
                   slot="reference"
                   @click="getFormatKeywordMethod(commentWord, 'click')">关键词检查</el-button>
        <div v-if="format_parse"
             style="padding:12px">
          <i class="el-icon-close"
             style="position:absolute;cursor:pointer;right:6px;top:6px;"
             @click.stop="visible = false"></i>
          <div style="font-size:13px">{{parse_word_title}}</div>
          <div style="font-size:13px"
               v-if="parse_word_subtitle">{{parse_word_subtitle}}</div>
          <div style="font-size:14px;color:#69c0ff;padding:5px 0"
               v-html="format_parse"></div>
          <div style="font-size:13px">确认逻辑无误再提交搜索，数据更精准哦</div>
        </div>
      </el-popover>
    </div>
    <!-- 价格搜索筛选 -->
    <div v-if="showSearch == 'price'"
         class="price-range-input">
      <el-input :placeholder="priceRangeMore"
                class="price-min-input"
                v-model="price_min">
        <template slot="suffix">元</template>
      </el-input>
      <span style="line-height: 30px; padding: 0px 5px;">~</span>
      <el-input :placeholder="priceRangeLess"
                class="price-max-input"
                v-model="price_max">
        <template slot="suffix">元</template>
        <el-button slot="append"
                   class="select-search-btn"
                   @click="searchPriceWords"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>
  </div>
</template>


<script>
import { getBrand } from '@/api/baseInfo'
import { getTitleWord } from '@/api/topItem'
import { transformPlat } from '@/utils'
import { changeUrlId } from '@/utils/handleUrlId.js'
import { buildSafeFilterParams } from '@/utils/filterParams'
import { getFormatKeyword } from '@/api/format.js'
import { urlParams } from '@/mixins/mixins.js'
export default {
  mixins: [urlParams],
  name: 'TopSearch',
  data() {
    return {
      keyword: '',
      options: [
        {
          value: 'item',
          label: '商品',
        },
        {
          value: 'brand',
          label: '品牌',
        },
        {
          value: 'comment',
          label: '评论',
        },
        {
          value: 'price',
          label: '价格',
        },
      ],
      value: '',
      itemInput: '可输入标题关键词或商品链接进行搜索',
      brandInput: '',
      commentInput: '请输入评论关键词或评论ID',
      showSearch: 'item',
      priceRangeMore: '大于等于此价格的商品',
      priceRangeLess: '小于等于此价格的商品',
      titleWord: '',
      titleTyp: 'skuandtitle',
      brandWord: '',
      commentWord: this.$store.state.user.contentWord,
      price_min: this.$store.state.user.priceMin,
      price_max: this.$store.state.user.priceMax,
      brandOptions: [],
      brandLoading: false,
      format_parse: '',
      parse_word_title: '',
      parse_word_subtitle: null,
      visible: false,
      isBlur: '',
      isSearchLoading: false,
    }
  },
  methods: {
    open() {
      this.$message('请选择品牌')
    },
    openConfirm(text, cb) {
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (cb && typeof cb === 'function') {
            cb()
          }
        })
        .catch(() => {})
    },
    changePlat(value) {
      this.showSearch = value
      this.visible = false
      this.format_parse = ''
    },
    changeSkuTitle(value) {
      this.titleTyp = value
    },
    searchTitleWords() {
      this.isSearchLoading = true
      const { plat, cid } = this.$store.state.user
      const titleParams = {
        title_word: this.titleWord,
        title_typ: this.titleTyp,
        plat: plat,
        cid: cid,
      }
      getTitleWord(titleParams)
        .then((res) => {
          this.isSearchLoading = false
          // 在返回结果有个code '-1'=商品关键词搜索  '-2'=商品链接搜索未找到商品 '0'=商品链接搜索返回item_id.
          if (res.status == 'ok') {
            const { result } = res
            if (res.result.code === '-1') {
              let query = _.cloneDeep(this.$route.query)
              let titleWord = []
              let titleWordList = this.titleWord.split(',')
              let set = new Set(titleWordList)
              titleWordList = Array.from(set)
              for (let i = 0; i < titleWordList.length; i++) {
                const element = titleWordList[i]
                let titleWordItem = {
                  word: element,
                  title_typ: this.titleTyp,
                }
                titleWord.push(titleWordItem)
              }
              this.$store.dispatch('user/changeTitleWordList', titleWord)
              this.$store.dispatch('user/changeIsTriggerSearchChange', true)
              changeUrlId(null, 'title_word', JSON.stringify(titleWord)).then(
                (url_id) => {
                  this.$store.dispatch(
                    'user/changeTitleWord',
                    JSON.stringify(titleWord)
                  )
                  this.$store.dispatch('user/changeTitleTyp', this.titleTyp)
                  query.url_id = url_id
                  this.$store.dispatch('user/changeActivedTab', 'Summary')
                  this.$router.push({
                    name: this.$route.name,
                    query,
                  })
                }
              )
            } else if (res.result.code === '0') {
              const loginCatlist = this.$store.state.user.loginInfo.cat_list
              let datas = window.cache_cat_jd
              switch (result.plat) {
                case 'jd':
                  datas = window.cache_cat_jd
                  break
                case 'tmall':
                  datas = window.cache_cat
                  break
                case 'custom':
                  datas = window.cache_cat_custom
                  break
                case 'douyin':
                  datas = window.cache_douyin_cats
                  break
                case 'amazon_us':
                  datas = window.cache_cat_amazon_us
                  break
                default:
                  datas = window.cache_cat_jd
              }
              const childrenList = datas.result.childrenList
              const findPath = (category_id) => {
                let node = childrenList[category_id]
                if (
                  !node &&
                  result.plat === 'jd' &&
                  category_id === result.cid &&
                  result.parent_cat_id != null &&
                  result.cid != null
                ) {
                  node = childrenList[`${result.parent_cat_id}_${result.cid}`]
                }
                if (!node) return []
                const { parent_id } = node
                if (parent_id === '0') {
                  return [node.category_id]
                } else {
                  return [...findPath(parent_id), node.category_id]
                }
              }
              let path = []
              const primaryCatKey = path[0] ? path[0] : result.cid
              const categoryTitleKey =
                result.plat === 'jd' &&
                childrenList[primaryCatKey] === undefined &&
                result.parent_cat_id != null &&
                result.cid != null
                  ? `${result.parent_cat_id}_${result.cid}`
                  : primaryCatKey
              if (['custom', 'amazon_us'].includes(result.plat)) {
                path = [result.cid]
              } else {
                path = findPath(result.cid)
              }
              if (loginCatlist != 'all') {
                const allIds = _.flatMap(loginCatlist[result.plat], (array) =>
                  _.map(array, 'cat_id')
                )
                const hasCommon = path.some((item) => allIds.includes(item))
                if (!hasCommon) {
                  let text = `您当前搜索的商品属于【${transformPlat(
                    result.plat
                  )}】平台【${
                    childrenList[categoryTitleKey].name
                  }】类目，您的账号还没有开通对应类目的权限，无法查看！`
                  this.openConfirm(text)
                } else if (result.plat == this.$route.query.plat && result.cid == this.$route.query.cid) {
                  const filterParams = buildSafeFilterParams(
                    this.$store.state.user.filterParams,
                    this.$route.query
                  )
                  filterParams.item_id = result.item_id
                  this.$store.dispatch('user/changeIsTriggerSearchChange', true)
                  changeUrlId(filterParams).then(() => {
                    this.$eventBus.$emit('changeCatById', result.cid)
                    this.$store.dispatch('user/changeItemId', result.item_id)
                    // this.$store.dispatch('user/changeCatId', result.cid)
                    this.$store.dispatch('user/changeActivedTab', 'Summary')
                  })
                } else {
                  let text = `您当前搜索的商品属于【${transformPlat(
                    result.plat
                  )}】平台【${
                    childrenList[categoryTitleKey].name
                  }】类目，是否要跳转到这个类目？`
                  this.openConfirm(text, () => {
                    changeUrlId({
                      plat: result.plat,
                      cat_id: result.cid,
                      item_id: result.item_id,
                      url_id: result.cid,
                      ...(result.parent_cat_id && {parent_cat_id: result.parent_cat_id}),
                    }).then((url_id) => {
                      this.$store.dispatch('user/changePlat', result.plat)
                      this.$store.dispatch('user/changeCatId', result.cid)
                      this.$store.dispatch('user/changeStart', result.start)
                      this.$store.dispatch('user/changeEnd', result.end)
                      this.$store.dispatch('user/changeItemId', result.item_id)
                      if(result.parent_cat_id){
                        this.$store.dispatch('user/changeParentCatId', result.parent_cat_id)
                      }
                      this.$router.push({
                        name: 'catSheet',
                        query: {
                          plat: result.plat,
                          cid: result.cid,
                          start: result.start,
                          end: result.end,
                          url_id: url_id,
                        },
                      })
                    })
                  })
                }
              } else if (result.plat == this.$route.query.plat && result.cid == this.$route.query.cid) {
                const filterParams = buildSafeFilterParams(
                  this.$store.state.user.filterParams,
                  this.$route.query
                )
                filterParams.item_id = result.item_id
                this.$store.dispatch('user/changeIsTriggerSearchChange', true)
                changeUrlId(filterParams).then(() => {
                  this.$eventBus.$emit('changeCatById', result.cid)
                  this.$store.dispatch('user/changeItemId', result.item_id)
                  // this.$store.dispatch('user/changeCatId', result.cid)
                  this.$store.dispatch('user/changeActivedTab', 'Summary')
                })
              } else {
                let text = `您当前搜索的商品属于【${transformPlat(
                  result.plat
                )}】平台【${
                  childrenList[categoryTitleKey].name
                }】类目，是否要跳转到这个类目？`
                this.openConfirm(text, () => {
                  changeUrlId({
                    plat: result.plat,
                    cat_id: result.cid,
                    item_id: result.item_id,
                    url_id: result.cid,
                    ...(result.parent_cat_id && {parent_cat_id: result.parent_cat_id}),
                  }).then((url_id) => {
                    this.$store.dispatch('user/changePlat', result.plat)
                    this.$store.dispatch('user/changeCatId', result.cid)
                    this.$store.dispatch('user/changeStart', result.start)
                    this.$store.dispatch('user/changeEnd', result.end)
                    this.$store.dispatch('user/changeItemId', result.item_id)
                    if(result.parent_cat_id){
                        this.$store.dispatch('user/changeParentCatId', result.parent_cat_id)
                    }
                    this.$router.push({
                      name: 'catSheet',
                      query: {
                        plat: result.plat,
                        cid: result.cid,
                        start: result.start,
                        end: result.end,
                        url_id: url_id,
                      },
                    })
                  })
                })
              }
            } else if (res.result.code === '-2') {
              this.$message.error(
                '对不起，您搜索的”' +
                  this.titleWord +
                  '”找不到对应的商品，请检查您的输入后重试。'
              )
            }
          } else {
            this.$message.error(res.error_msg || '服务器错误，请截屏并联系客服')
          }
        })
        .catch((err) => {
          this.isSearchLoading = false
          this.$message.error(err.backMsg || '服务器错误，请截屏并联系客服')
        })
    },
    searchCommentWords() {
      this.$store.dispatch('user/changeIsTriggerSearchChange', true)
      changeUrlId(null, 'content_word', this.commentWord).then(() => {
        this.$store.dispatch('user/changeContentWord', this.commentWord)
        this.$store.dispatch('user/changeActivedTab', 'Summary')
      })
    },
    searchPriceWords() {
      let query = _.cloneDeep(this.$route.query)
      this.$store.dispatch('user/changeIsTriggerSearchChange', true)
      changeUrlId(
        null,
        ['price_min', 'price_max'],
        [this.price_min, this.price_max]
      ).then((result) => {
        this.$store.dispatch('user/changePriceMin', this.price_min)
        this.$store.dispatch('user/changePriceMax', this.price_max)
        query.url_id = result
        this.$store.dispatch('user/changeActivedTab', 'Summary')
        this.$router.push({
          name: this.$route.name,
          query,
        })
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.brandLoading = true
        const { plat, cid, start, end } = this.$route.query
        const params = {
          cat_id: cid,
          url_id: cid,
          plat: plat,
          parent_cat_id: this.$store.state.user.parentCatId,
          start: start,
          end: end,
          word: query,
          ts_type: this.tsType,
        }
        getBrand(params).then((res) => {
          this.brandLoading = false
          if (res.status == 'ok') {
            const { data } = res.result
            this.brandOptions = data.map((item) => {
              return {
                label: item.brand_name,
                value: item.brand_id,
              }
            })
          } else {
            this.brandOptions = []
          }
        })
      } else {
        this.brandOptions = []
      }
    },
    keyWordFocus() {
      this.visible = false
      this.format_parse = ''
    },
    getFormatKeywordMethod(word, type) {
      if (this.visible || this.isBlur == 'blur') {
        return
      }
      if (type == 'blur') {
        this.isBlur = 'blur'
      }
      if (word && word !== this.format_parse) {
        const param = {
          word: word,
        }
        getFormatKeyword(param).then((res) => {
          if (res.status == 'ok') {
            if (res.result.state == 'ok') {
              this.parse_word_title =
                '系统会按照以下格式来理解您输入的关键词表达式'
              this.format_parse = res.result.format_parse
            } else if (res.result.state == 'error') {
              if (res.result.error_type == 0) {
                this.parse_word_title = '您的关键词表达式有误！'
                this.parse_word_subtitle = null
                let textArr = word.split('')
                textArr[
                  [res.result.format_parse[0]]
                ] = `<span style="color:red">${
                  textArr[res.result.format_parse[0]]
                }</span>`
                this.format_parse = textArr.join('')
              } else if (res.result.error_type == 1) {
                this.parse_word_title = '关键词检索不支持中文顿号/逗号/引号'
                this.parse_word_subtitle =
                  '您是否想以and或or的关系筛选多个关键词？'
                let textArr = word.split('')
                textArr[
                  [res.result.format_parse[0]]
                ] = `<span style="color:red">${
                  textArr[res.result.format_parse[0]]
                }</span>`
                this.format_parse = textArr.join('')
              } else if (res.result.error_type == 2) {
                this.parse_word_title =
                  'and/or/not前后需要加空格，才能生效哦！请修改'
                this.parse_word_subtitle = null
                let parseArr = res.result.format_parse
                let textArr =
                  word.substring(0, parseArr[0]) +
                  `<span style="color:red">${word.substring(
                    parseArr[0],
                    parseArr[1]
                  )}</span>` +
                  word.substring(parseArr[1], word.length)
                this.format_parse = textArr
              }
            }
            this.visible = true
          }
        })
      } else if (word && word == this.format_parse) {
        this.visible = true
      } else if (!word && type == 'click') {
        this.$message.warning('请输入关键词！')
      }
    },
    addBrandId(value) {
      this.brandWord = ''
      const filterParams = buildSafeFilterParams(
        this.$store.state.user.filterParams,
        this.$route.query
      )
      filterParams.brand_id = value
      changeUrlId(filterParams).then(() => {
        this.$store.dispatch('user/changeBrandId', value)
        this.$store.dispatch('user/changeActivedTab', 'Summary')
      })
    },
    handleClickOutsideItem(event) {
      if (this.isBlur) {
        this.isBlur = ''
        return
      }
      if (
        this.$refs.itemPopover &&
        !this.$refs.itemPopover.contains(event.target) &&
        this.visible
      ) {
        this.visible = false
      }
    },
    handleClickOutsideComment(event) {
      if (this.isBlur) {
        this.isBlur = ''
        return
      }
      if (
        this.$refs.commentPopover &&
        !this.$refs.commentPopover.contains(event.target) &&
        this.visible
      ) {
        this.visible = false
      }
    },
  },
  computed: {
    tsType() {
      return this.$store.state.user.tsType
    },
  },
  mounted() {
    this.$eventBus.$on('deleteTitleWord', (title_word) => {
      this.titleWord = title_word
    })
    this.$eventBus.$on('deleteBrandWord', () => {
      this.brandWord = ''
    })
    this.$eventBus.$on('deleteContentWord', () => {
      this.commentWord = ''
    })
    this.$eventBus.$on('deletePriceWord', () => {
      this.price_min = ''
      this.price_max = ''
    })
    document.addEventListener('click', this.handleClickOutsideItem)
    document.addEventListener('click', this.handleClickOutsideComment)
  },
  beforeDestroy() {
    this.$eventBus.$off('deleteTitleWord')
    this.$eventBus.$off('deleteBrandWord')
    this.$eventBus.$off('deleteContentWord')
    this.$eventBus.$off('deletePriceWord')
    document.removeEventListener('click', this.handleClickOutsideItem)
    document.removeEventListener('click', this.handleClickOutsideComment)
  },
  watch: {
    '$store.state.user.titleWord': {
      handler(newVal, oldVal) {
        if (newVal) {
          let title_word_str = ''
          try {
            const parsed = JSON.parse(newVal)
            if (Array.isArray(parsed)) {
              title_word_str = parsed.map((item) => item.word || item).join(',')
            } else if (parsed && typeof parsed === 'object') {
              title_word_str = parsed.word || newVal
            } else {
              title_word_str = newVal
            }
          } catch (e) {
            title_word_str = newVal
          }

          this.titleWord = title_word_str
        }
      },
    },
    // $route: {
    //   handler(newVal, oldVal) {
    //     // route改变后清空搜索框
    //     if (newVal.name !== oldVal.name) {
    //       this.titleWord = ''
    //       this.commentWord = ''
    //       this.price_min = ''
    //       this.price_max = ''
    //     }
    //   }
    // }
  },
}
</script>

<style scoped lang="less">
.open-btn {
  width: 40px;
  height: 30px;
  line-height: inherit;
  border-radius: 0px;
  padding: 0px;
}
.open-btn:hover,
.open-btn:focus,
.open-btn:active {
  color: #ffffff;
  border-color: #dcdfe6;
  background-color: #ffffff;
}
.sku-title {
  font-size: 14px;
  color: #907c7c;
  margin-bottom: 4px;
  .sku-tip {
    display: inline-block;
    font-size: 12px;
    color: #85868a;
  }
}
.search {
  display: flex;
  position: relative;
  /deep/ .el-icon-search {
    font-size: 17px;
    color: #85868a;
  }
  .item-select {
    width: 75px;
    /deep/ input {
      height: 30px;
      font-size: 14px;
      color: #ffffff;
      background-color: #ff7d00;
      border-color: #ff7d00;
      border-radius: unset;
      padding: 0 10px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #ffffff;
    }
    /deep/ i {
      color: #ffffff;
    }
    /deep/ .el-select-dropdown__list {
      padding: 0;
    }
    /deep/ .popper__arrow {
      display: none;
    }
    /deep/ .el-popper {
      border: 1px solid #707070;
      border-radius: 0;
      margin-top: 0px;
      left: 0px !important;
    }
  }
  .price-range-input {
    display: flex;
    /deep/ input {
      width: 180px;
      height: 30px;
      border-radius: 0;
      padding: 0;
    }
    /deep/ .el-input__suffix {
      height: 30px;
      font-size: 12px;
      color: #85868a;
      background-color: #ffffff;
      border-radius: 0;
      border: 1px solid #ccc;
      padding: 0 5px;
      right: 0;
      .el-input__suffix-inner {
        line-height: 30px;
      }
    }
    /deep/ .el-input-group__append {
      background: #ffffff;
      border-radius: unset;
      padding: 0 10px;
    }
  }
  .search-input {
    width: 360px;
    margin-right: 10px;
    /deep/ input {
      height: 30px;
      line-height: 30px;
      border-radius: unset;
    }
    /deep/ .el-input-group__append {
      background: #ffffff;
      border-radius: unset;
      padding: 0 10px;
    }
  }
  .keyword-search {
    width: 65px;
    height: 30px;
    font-size: 13px;
    color: #ff7d00;
    border: unset;
    padding: 0;
  }
  .keyword-search:active,
  .keyword-search:focus,
  .keyword-search:hover {
    color: #ff7d00;
    background: unset;
    border: unset;
  }
  .tool-item {
    position: absolute;
    z-index: 12;
    color: #85868a;
    line-height: 30px;
    right: 65px;
  }
  .tool-item-keyword {
    position: absolute;
    z-index: 12;
    color: #85868a;
    line-height: 30px;
    right: 130px;
  }
}
.tophead-select-popper {
  .el-select-dropdown__item {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #ffffff;
    font-weight: normal;
    background-color: #ff7d00;
    padding: 0 10px;
  }
  .el-select-dropdown__item.selected {
    font-weight: normal;
    background-color: #ff7d00;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #ffffff;
    font-weight: normal;
    background-color: #1798fb;
  }
}
</style>
